import { ReactNode } from 'react'
import { Spinner, Center } from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api'

type CurrentUserSelfRequestWrapperProps = {
  children: (userId: string) => ReactNode
}

export const CurrentUserSelfRequestWrapper = ({
  children
}: CurrentUserSelfRequestWrapperProps) => {
  const selfQuery = useQuery(dashboardv99990101Client.getSelf)

  const self = selfQuery.data

  if (!self || selfQuery.isPending) {
    return (
      <Center width="100%" height="100%">
        <Spinner />
      </Center>
    )
  }

  return children(self.sequenceUser.id)
}
